module.exports = __webpack_public_path__ + "img/Jump Casting107.536064b0.jpg";